export const API_URL = process.env.REACT_APP_API_BASE_URL;
export const API_IMAGE_URL = `${process.env.REACT_APP_API_BASE_URL}/api/image/`;

export const GENDER_GREETING_TEXT = {
  'M': '你好',
  'F': '妳好',
  'U': ''
};